export const branchInspectionQueryKeys = {
  id: 'id',
  branchId: 'branch_id',
  stateId: 'state_id',
  note: 'note',
  deadline: 'deadline',
  startedAt: 'started_at',
  completedAt: 'completed_at',
  createdBy: 'created_by',
  createdByUserName: 'created_by_user.name',
  executedByUserName: 'executed_by_user.name',
  createdAt: 'created_at',
  updatedAt: 'updated_at',
};
